const editProfile = "/edit-profile";
const viewProfile = "/view-profile";

export const path = {
  editProfile: {
    route: editProfile,
    link: () => editProfile,
  },
  viewProfile: {
    route: viewProfile,
    link: () => viewProfile,
  },
};
